import { Icon, Tooltip } from '@statsbomb/kitbag-components';
import { Trans } from 'react-i18next';

export const ThreeSixtyIcon = ({ i18nKey }: { i18nKey?: string }) =>
  i18nKey ? (
    <Tooltip content={<Trans i18nKey={i18nKey} ns="filters" />}>
      <Icon variant="ThreeSixty" size="small" testId="360-icon" />
    </Tooltip>
  ) : (
    <Icon variant="ThreeSixty" size="small" testId="360-icon" />
  );

export const MetricThreeSixtyIcon = () => <ThreeSixtyIcon i18nKey="metricThreeSixtyTooltip" />;
